import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { setQuater } from "../../store/actions/detailsDocument/quater";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class QuaterSezionali extends Component {
  static propTypes = {
    auth: PropTypes.object,
    setQuater: PropTypes.func,
    accountantSelected: PropTypes.string,
    accountantIdSelected: PropTypes.string,
    companySelected: PropTypes.string,
    clientIdSelected: PropTypes.string
  };

  setQuaterActive(
    auth, documentId, quater, companySelected, clientIdSelected, accountantSelected
  ) {
    const { setQuater, accountantIdSelected } = this.props;
    setQuater(
      auth, documentId, quater, companySelected, clientIdSelected, accountantSelected, accountantIdSelected
    );
  }

  renderQuaterSezionali() {
    const {
      companySelected,
      clientIdSelected,
      accountantSelected,
      auth,
      detailsDocument: { info }
    } = this.props;
    let arrayQuater = [];
    let arraySezionali = [];
    if (info.status.started) {
      return <FontAwesomeIcon icon={["far", "circle-notch"]} spin />;
    } 
    if (info.status.ended && info.details) {
      let self = this;
      info.details.quaters.forEach(function(key, index) {
        arrayQuater.push(<div
          key={"quater_" + info.details.quaters[index].value}
          className={"tagDetails " + (info.details.quaters[index].active ? "active" : "")}
          onClick={e => {
            self.setQuaterActive(
              auth, info.details.documentId, info.details.quaters[index].value, companySelected, clientIdSelected, accountantSelected
            );
          }}
        >
          {info.details.quaters[index].value}
        </div>);
      });
      info.details.sectionals.forEach(function(key, index) {
        arraySezionali.push(<div
          key={"sezionali_" + info.details.sectionals[index].value}
          className={"tagDetails " + (info.details.sectionals[index].active ? "active" : "")}
          onClick={() => {
          }}
        >
          {info.details.sectionals[index].value}
        </div>);
      });
    }

    return (
      <div>
        <div>{arrayQuater}</div>
        <div>{arraySezionali}</div>
      </div>
    );
  }
  render() {
    return <div className="containerTagsDetails">{this.renderQuaterSezionali()}</div>;
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    detailsDocument: state.detailsDocument
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setQuater: (
      auth, documentId, quater, companySelected, clientIdSelected, accountantSelected, accountantIdSelected
    ) => {
      dispatch(setQuater(
        auth, documentId, quater, companySelected, clientIdSelected, accountantSelected, accountantIdSelected
      ));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(QuaterSezionali);
